module.exports = __webpack_public_path__ + "img/default-btn-zh.be6a9463.png";